<input
  #countryInput
  data-1p-ignore
  data-bwignore
  data-lpignore="true"
  data-form-type="other"
  autocomplete="off"
  id="country"
  type="text"
  class="form-control"
  [disabled]="disabled"
  [ngbTypeahead]="countrySearch"
  [resultTemplate]="rt"
  [inputFormatter]="countryInputFormatter"
  (selectItem)="onCountrySelect($event)"
  [editable]="false"
  (blur)="onBlur()"
  (input)="onCountryInput($any($event).target.value)"
  (focus)="countrySelectorFocus$.next($any($event).target.value)"
  (click)="countrySelectorClick$.next($any($event).target.value)"
  placeholder="{{ 'component.country-selector.placeholder' | translate }}"
/>

<ng-template #rt let-result="result" let-term="term">
  <ngb-highlight [result]="result.name" [term]="term"></ngb-highlight>
</ng-template>
